import parse from "html-react-parser";
import { CTabPane } from "@coreui/react";
import "@coreui/coreui/dist/css/coreui.min.css";

import { TextS } from "../../common/text";

const TicketDetailTabContent = ({
  activeKey,
  ticket: {
    product: { info, cancelInfo },
  },
}) => {
  if (activeKey === 1) {
    return (
      <CTabPane role="tabpanel" visible={activeKey === 1}>
        <TextS style={{ lineHeight: "1.5", whiteSpace: "pre-wrap" }}>
          {info && parse(info)}
        </TextS>
      </CTabPane>
    );
  } else if (activeKey === 2) {
    return (
      <CTabPane role="tabpanel" visible={activeKey === 2}>
        <TextS style={{ lineHeight: "1.5", whiteSpace: "pre-wrap" }}>
          {cancelInfo && parse(cancelInfo)}
        </TextS>
      </CTabPane>
    );
  }
};

export default TicketDetailTabContent;
